import moment from "moment";

export const state = () => ({
  headers: [],
  filters: {
    search: "",
    program: null,
    assessment_status: null,
    care_plan_status: null,
    coordinator_id: null,
    facilities: null,
    tags: null,
    start_date: moment().subtract(1, "year").format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),
  },
});


export const mutations = {
  SET_HEADERS(state, headers) {
    state.headers = headers;
  },

  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters };
  },
  SET_SEARCH(state, search) {
    state.filters.search = search;
  },
  RESET_FILTERS(state) {
    state.filters = {
      search: "",
      program: null,
      assessment_status: null,
      care_plan_status: null,
      coordinator_id: null,
      facilities: null,
      tags: null,
      start_date: moment().subtract(1, "year").format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
    };
  },
};

export const actions = {
  // Headers actions
  setTableHeaders({ commit }, { headers }) {
    commit("SET_HEADERS", headers);
  },

  // Filters actions
  setFilters({ commit }, filters) {
    commit("SET_FILTERS", filters);
  },
  setSearch({ commit }, search) {
    commit("SET_SEARCH", search);
  },
  resetFilters({ commit }) {
    commit("RESET_FILTERS");
  },
};

export const getters = {
  getHeaders:
    (state) =>
    (app, actions_key = "medrina_patient_actions") => {
      let headers = [];

      const defaultHeaders = [
        {
          key: "display_name",
          label: "Patient Name",
          display: true,
          sortable: true,
          default: true
        },
        {
          key: "programs",
          label: "Programs",
          display: true,
          sortable: false,
          default: true
        },
        {
          key: "external_patient_id",
          label: "ID",
          display: true,
          sortable: true,
          default: true
        },
        {
          key: "assessment_status",
          label: "Assessment Status",
          display: true,
          sortable: true,
          default: true
        },
        {
          key: "care_plan_status",
          label: "Care Plan Status",
          display: true,
          sortable: true,
          default: true
        }
      ];

      if (state.headers.length) {
        headers = [...state.headers];
      } else {
        headers = defaultHeaders.filter((header) => header.default);
      }

      // Add localization if available
      headers = headers.map((header) => {
        header.label = app.$te(`tables.medrina_patients.${header.key}`)
          ? app.$t(`tables.medrina_patients.${header.key}`).replace(/&amp;/g, "&")
          : header.label.replace(/&amp;/g, "&");
        return header;
      });

      // Add actions column
      headers.push({
        key: actions_key,
        label: app.$t("tables.actions"),
        display: true,
        stickyColumn: true,
      });

      return headers;
    },

  // Filters getters
  getFilters: (state) => () => {
    return state.filters;
  },
  getSearch: (state) => () => {
    return state.filters.search;
  },
};
